/* click-to-zoom lightbox with prev/next navigation
   Targets: .pdp-block--variant-gallery hero+thumbs, and .banner__image
   (Concept's product-media-environment slideshow). */
(function pdpLightbox() {
  if (window.__pdpLightboxInit) return;
  window.__pdpLightboxInit = true;

  let overlay = null;
  const state = { items: [], idx: 0 };

  function ensureOverlay() {
    if (overlay) return overlay;
    const style = document.createElement('style');
    style.textContent =
      '.pdp-lightbox{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.86);' +
      'display:none;align-items:center;justify-content:center;padding:20px;' +
      'opacity:0;transition:opacity 200ms ease}' +
      '.pdp-lightbox[data-open="true"]{display:flex;opacity:1}' +
      '.pdp-lightbox__backdrop{position:absolute;inset:0;cursor:zoom-out}' +
      '.pdp-lightbox__img{max-width:90vw;max-height:92vh;object-fit:contain;' +
      'box-shadow:0 30px 80px rgba(0,0,0,.5);position:relative;z-index:1}' +
      '.pdp-lightbox__close,.pdp-lightbox__nav{position:absolute;width:48px;height:48px;' +
      'border-radius:50%;background:rgba(255,255,255,.18);color:#fff;font-size:24px;line-height:1;' +
      'display:grid;place-items:center;border:0;cursor:pointer;z-index:2;' +
      'transition:background 180ms ease}' +
      '.pdp-lightbox__close:hover,.pdp-lightbox__nav:hover{background:rgba(255,255,255,.32)}' +
      '.pdp-lightbox__close{top:24px;right:24px}' +
      '.pdp-lightbox__nav{top:50%;transform:translateY(-50%);font-size:30px}' +
      '.pdp-lightbox__nav--prev{left:24px}' +
      '.pdp-lightbox__nav--next{right:24px}' +
      '.pdp-lightbox__nav[hidden]{display:none}' +
      '.pdp-lightbox__counter{position:absolute;bottom:24px;left:50%;transform:translateX(-50%);' +
      'color:rgba(255,255,255,.7);font-size:13px;letter-spacing:.04em;z-index:2;' +
      'font-variant-numeric:tabular-nums}' +
      '@media (max-width:600px){.pdp-lightbox__nav--prev{left:8px}.pdp-lightbox__nav--next{right:8px}' +
      '.pdp-lightbox__close{top:12px;right:12px}}' +
      '[data-pdp-lightbox-trigger]{cursor:zoom-in}';
    document.head.appendChild(style);

    overlay = document.createElement('div');
    overlay.className = 'pdp-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="pdp-lightbox__backdrop"></div>' +
      '<button type="button" class="pdp-lightbox__close" aria-label="Close">×</button>' +
      '<button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--prev" aria-label="Previous">‹</button>' +
      '<button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--next" aria-label="Next">›</button>' +
      '<img class="pdp-lightbox__img" alt="">' +
      '<div class="pdp-lightbox__counter" aria-hidden="true"></div>';
    document.body.appendChild(overlay);

    const closeEl = overlay.querySelector('.pdp-lightbox__close');
    const backdrop = overlay.querySelector('.pdp-lightbox__backdrop');
    const prevBtn = overlay.querySelector('.pdp-lightbox__nav--prev');
    const nextBtn = overlay.querySelector('.pdp-lightbox__nav--next');

    function close() {
      overlay.setAttribute('data-open', 'false');
      setTimeout(() => { overlay.style.display = 'none'; }, 220);
      document.documentElement.style.overflow = '';
    }
    closeEl.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    prevBtn.addEventListener('click', (e) => { e.stopPropagation(); navigate(-1); });
    nextBtn.addEventListener('click', (e) => { e.stopPropagation(); navigate(1); });

    document.addEventListener('keydown', (e) => {
      if (overlay.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') navigate(-1);
      else if (e.key === 'ArrowRight') navigate(1);
    });

    // Swipe navigation on the image itself
    let touchStart = null;
    overlay.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { touchStart = null; return; }
      touchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }, { passive: true });
    overlay.addEventListener('touchend', (e) => {
      if (!touchStart) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStart.x;
      const dy = t.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        navigate(dx < 0 ? 1 : -1);
      }
    }, { passive: true });

    return overlay;
  }

  function show(idx) {
    const n = state.items.length;
    if (n === 0) return;
    state.idx = ((idx % n) + n) % n;
    const item = state.items[state.idx];
    const img = overlay.querySelector('.pdp-lightbox__img');
    img.src = item.src;
    img.alt = item.alt || '';
    const prev = overlay.querySelector('.pdp-lightbox__nav--prev');
    const next = overlay.querySelector('.pdp-lightbox__nav--next');
    const counter = overlay.querySelector('.pdp-lightbox__counter');
    const showNav = n > 1;
    prev.hidden = !showNav;
    next.hidden = !showNav;
    counter.textContent = showNav ? (state.idx + 1) + ' / ' + n : '';
  }

  function navigate(dir) {
    show(state.idx + dir);
  }

  function openWithSet(items, startIdx) {
    const ov = ensureOverlay();
    state.items = items;
    ov.style.display = 'flex';
    requestAnimationFrame(() => ov.setAttribute('data-open', 'true'));
    document.documentElement.style.overflow = 'hidden';
    show(startIdx);
  }

  function getFullSrc(img) {
    if (img.dataset.lightboxSrc) return img.dataset.lightboxSrc;
    if (img.srcset) {
      let best = { url: img.src, w: 0 };
      img.srcset.split(',').forEach((s) => {
        const parts = s.trim().split(/\s+/);
        const w = parseInt(parts[1]) || 0;
        if (w > best.w) best = { url: parts[0], w: w };
      });
      return best.url;
    }
    return img.src;
  }

  function collectSet(img) {
    /* Variant gallery: items = all thumbs in the active .variant-gallery__group */
    const variantGroup = img.closest('.variant-gallery__group');
    if (variantGroup) {
      const thumbs = Array.from(variantGroup.querySelectorAll('[data-hero-src]'));
      const items = thumbs.map((li) => {
        const tImg = li.querySelector('img');
        return {
          src: li.dataset.heroSrc || (tImg && (tImg.currentSrc || tImg.src)) || '',
          alt: tImg ? tImg.alt : ''
        };
      });
      let startIdx = 0;
      /* Hero click → use the currently-active thumb */
      if (img.matches('[data-variant-hero]')) {
        const active = variantGroup.querySelector('[data-hero-src][aria-current="true"]');
        if (active) startIdx = thumbs.indexOf(active);
      } else {
        /* Thumb click → find self */
        const thumbLi = img.closest('[data-hero-src]');
        if (thumbLi) startIdx = thumbs.indexOf(thumbLi);
      }
      if (items.length === 0) {
        items.push({ src: getFullSrc(img), alt: img.alt });
      }
      return { items, startIdx: Math.max(startIdx, 0) };
    }

    /* Concept slideshow: items = all banner__image in the same slideshow */
    const slideshow = img.closest('slideshow-element, .slideshow');
    if (slideshow) {
      const imgs = Array.from(slideshow.querySelectorAll('.banner__image'));
      let startIdx = 0;
      const items = imgs.map((el, i) => {
        if (el === img) startIdx = i;
        return { src: getFullSrc(el), alt: el.alt };
      });
      return { items, startIdx };
    }

    /* Fallback: single image */
    return { items: [{ src: getFullSrc(img), alt: img.alt }], startIdx: 0 };
  }

  function bind(img) {
    if (img.dataset.pdpLightboxBound) return;
    img.dataset.pdpLightboxBound = '1';
    img.setAttribute('data-pdp-lightbox-trigger', '');
    img.addEventListener('click', (e) => {
      e.preventDefault();
      const set = collectSet(img);
      openWithSet(set.items, set.startIdx);
    });
  }

  function scan() {
    // Only the big hero image opens the fullscreen lightbox. Thumbnails just
    // swap the hero (handled by bindVariantGalleryThumbs in pdp-nagami.js), so
    // we deliberately do NOT bind them here.
    document.querySelectorAll(
      '.pdp-block--variant-gallery .workspace__hero img,' +
      '.banner__image'
    ).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
